import { ComplianceEntity } from "@wingspanhq/wingspan-api-sdk";
import { selectorComplianceEntityCountry } from "../../../shared/selectors/selectorComplianceEntityCountry";

/**
 * Tax withholdings are US-only.
 *
 * v1 checked the monitored entity's country and fell back to the member
 * profile's address country. That fallback is gone: the v1 member profile is
 * retired and v3 exposes the country only on the compliance entity — so an
 * account whose compliance entity is not yet resolved is treated as eligible,
 * matching the v1 default when neither source said otherwise.
 */
export const selectorCanEnableTaxWithholdings = (
  monitoredEntity?: ComplianceEntity
) => {
  const country = selectorComplianceEntityCountry(monitoredEntity);

  return country === undefined || country === "US";
};
